import React from "react"
import { Icon } from "@mostlycode/ui"
import styled from "styled-components"
import Button from "../Button"
import Section from "../Section"
import { linkResolver } from "utils/linkResolver"
import { valuable } from "utils/worthy"

const StyledSection = styled(Section)`
  padding-top: 0;
`

function CTAButton(data) {
  const { display_text, link } = data.data
  return (
    <StyledSection
      align="center"
      append={
        <article>
          <p>
            <Button
              forwardedAs="a"
              icon="right"
              variant="secondary"
              href={valuable(link) ? link.url || linkResolver(link._meta) : ""}
            >
              {display_text}
              <Icon icon="long-arrow-right" />
            </Button>
          </p>
        </article>
      }
    />
  )
}

export default CTAButton
